import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import { guidFor } from '@ember/object/internals';
import { service } from '@ember/service';
import { capitalize } from '@ember/string';
import Component from '@glimmer/component';
import type IntlService from 'ember-intl/services/intl';
import { modifier } from 'ember-modifier';

type ValueType = string | boolean | undefined | null;
export interface Signature {
  Element: HTMLDivElement;
  Args: {
    label?: string;
    dataTestValue?: string;
    value?: ValueType;
    propertyName: string;
    translationKey?: string;
    disabled?: boolean;
    isReadOnly?: boolean;
    name?: string;
    current?: string | boolean;
    onChange: (v: ValueType) => void;
  };
  Blocks: { default: [] };
}

export default class BasicRadioComponent extends Component<Signature> {
  @service declare intl: IntlService;
  #isInitialized = false;

  get elementId(): string {
    return guidFor(this);
  }
  get dataTestRadioFor(): string {
    return (
      this.args.dataTestValue || this.args.propertyName + '-' + this.args.value
    );
  }

  get label(): string {
    if (this.args.label) return this.args.label;

    if (this.args.translationKey)
      return capitalize(
        this.intl.t(`${this.args.translationKey}.${this.args.value}`)
      );

    return '';
  }

  _updateDisabled = (element: HTMLElement): void => {
    if (this.args.disabled || this.args.isReadOnly) {
      /** @ts-expect-error TODO */
      $(element).checkbox('set disabled');
    } else {
      /** @ts-expect-error TODO */
      $(element).checkbox('set enabled');
    }
  };

  _updateChecked = (element: HTMLElement): void => {
    if (this.args.value == this.args.current) {
      /** @ts-expect-error TODO */
      $(element).checkbox('set checked');
    } else {
      /** @ts-expect-error TODO */
      $(element).checkbox('set unchecked');
    }
  };

  _setup = (element: HTMLElement): void => {
    /** @ts-expect-error TODO */
    $(element).checkbox({
      onChange: () => {
        /** @ts-expect-error TODO */
        if ($(element).checkbox('is checked')) {
          this.args.onChange(this.args.value);
        }
      }
    });
    this.#isInitialized = true;
  };

  updateRadioModifier = modifier((element: HTMLElement) => {
    if (!this.#isInitialized) this._setup(element);

    this._updateChecked(element);
    this._updateDisabled(element);
  });

  <template>
    <div
      class='ui checkbox radio'
      data-test-radio-for={{this.dataTestRadioFor}}
      ...attributes
      {{this.updateRadioModifier @current @disabled}}
    >
      <input
        id={{this.elementId}}
        type='radio'
        name={{@name}}
        {{on 'change' (fn @onChange @value)}}
      />
      <label>{{this.label}}</label>
      {{yield}}
    </div>
  </template>
}
